module.exports = __webpack_public_path__ + "static/img/partner1.f19ef7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner1.png
// module id = fMvF
// module chunks = 8